import React, { useEffect, useState } from 'react';
import { buildQuimedikDocumentPayload } from '@/utils/buildQuimedikDocumentPayload';
import { processPaymentRequest, postMedicalHistory } from '@/services/medicalHistoryService';
import { emitQuimedikDocument } from '@/services/quimedikInvoiceService';
import emailjs from '@emailjs/browser';

const resolveInvoicePdfUrl = (emitResult) => {
  if (!emitResult || typeof emitResult !== 'object') return null;
  const links = emitResult.links ?? emitResult.data?.links;
  const url = links?.pdf ?? links?.PDF;
  return typeof url === 'string' && url.length > 0 ? url : null;
};

const BotonPagoCulqi = ({ email, jsonToPay, setIsPaymentSuccess, onElectronicInvoicePdfUrl }) => {
  const [isProcessing, setIsProcessing] = useState(false);
  const monto = jsonToPay?.costo_de_consulta;

  useEffect(() => {
    if (window.Culqi) {
      //window.Culqi.publicKey = 'pk_test_mvu6DHfpdwf2LLYZ';
      window.Culqi.publicKey = 'pk_live_779aff20b5fa8487';
    }
    

    window.culqi = async function () {
      if (window.Culqi.token) {
        const tk = window.Culqi.token;
        let tokenId;
        let culqiCheckoutEmail;

        if (tk && typeof tk === 'object' && tk.id) {
          tokenId = tk.id;
          culqiCheckoutEmail = tk.email;
        } else if (typeof tk === 'string') {
          tokenId = tk;
        } else {
          tokenId = undefined;
        }

        const cargoEmail =
          typeof culqiCheckoutEmail === 'string' && culqiCheckoutEmail.trim()
            ? culqiCheckoutEmail.trim()
            : email;
        window.Culqi.close();
        setIsProcessing(true);
        try {
          const response = await processPaymentRequest({
            token: tokenId,
            email: cargoEmail,
            amount: Math.round(monto * 100),
          });

          const data = await response.json();

          if (response.ok) {
            const jsonToSend = { ...jsonToPay, rpta_culqi: data.id || data.data.id };
            await postMedicalHistory(jsonToSend);

            const quimedikPayload = buildQuimedikDocumentPayload({
              ruc_dni_en_factura: jsonToPay.ruc_dni_en_factura,
              nombre_razon_social_en_factura:
                jsonToPay.nombre_razon_social_en_factura || jsonToPay.__invoice_razon_social,
              document_type: jsonToPay.__invoice_document_type,
              costo_de_consulta: jsonToPay.costo_de_consulta,
              fecha_de_atencion: jsonToPay.fecha_de_atencion,
              hora_de_atencion: jsonToPay.hora_de_atencion,
              numero_de_historia_clinica: jsonToPay.numero_de_historia_clinica,
              codigo_hist: jsonToPay.codigo,
              titulo_servicio: jsonToPay.__invoice_servicio_titulo,
              paciente_completo: jsonToPay.__invoice_paciente_completo,
              culqiPaymentId: jsonToSend.rpta_culqi,
            });
            if (quimedikPayload) {
              const emitResult = await emitQuimedikDocument(quimedikPayload);
              const pdfUrl = resolveInvoicePdfUrl(emitResult);
              if (pdfUrl && typeof onElectronicInvoicePdfUrl === 'function') {
                onElectronicInvoicePdfUrl(pdfUrl);
              }
            }

            const templateParams = {
              user_name: 'Usuario',
              reply_to: cargoEmail,
              copy_to: cargoEmail,
              message:
                'Estimado paciente su cita fué pagada correctamente. La fecha de atención es: ' +
                jsonToSend?.fecha_de_atencion +
                ' a las ' +
                jsonToSend?.hora_de_atencion,
            };

            emailjs
              .send('service_zdu3k6p', 'template_3zc9p4j', templateParams, 'SuYqnE4z3_IEWAh90')
              .then(
                (response) => {
                  console.log('ÉXITO!', response.status, response.text);
                },
                (err) => {
                  console.log('FALLÓ...', err);
                },
              );

            setIsPaymentSuccess(true);
          } else {
            alert('Error: ' + (data.message || 'No se pudo procesar'));
          }
        } catch (error) {
          alert('Error de conexión con el servidor.');
        } finally {
          setIsProcessing(false);
        }
      } else {
        console.log('Error de Culqi: ', window.Culqi.error);
        alert(window.Culqi.error.user_message);
      }
    };
  }, [monto, email, jsonToPay, setIsPaymentSuccess, onElectronicInvoicePdfUrl]);

  const abrirCheckout = () => {
    if (isProcessing) return;

    if (window.Culqi) {
      window.Culqi.settings({
        title: 'Centro Médico Dr. Q',
        currency: 'PEN',
        description: 'Consulta Médica',
        amount: Math.round(monto * 100),
      });

      window.Culqi.options({
        lang: 'auto',
        modal: true,
        installments: false,
        customButton: '',
        style: {
          //logo: 'https://tu-url-logo.com/logo.png',
        },
      });

      window.Culqi.open();
    } else {
      alert('El sistema de pagos está cargando, por favor espera un momento...');
      // Opcional: podrías intentar recargar la página
      //window.location.reload();
    }
  };

  return (
    <button
      onClick={abrirCheckout}
      disabled={isProcessing}
      style={{
        backgroundColor: isProcessing ? '#ccc' : '#ff5c13', // Cambio visual si está cargando
        color: 'white',
        padding: '12px 24px',
        border: 'none',
        borderRadius: '8px',
        fontWeight: 'bold',
        cursor: isProcessing ? 'not-allowed' : 'pointer',
        transition: 'background-color 0.3s',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '10px',
      }}
    >
      {isProcessing ? 'PROCESANDO...' : 'PAGAR AHORA CON CULQI'}
    </button>
  );
};

export default BotonPagoCulqi;
